import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const CHARGING: AppRouteRecordRaw = {
  path: '/charging',
  name: 'charging',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '充电管理',
    icon: 'icon-flash',
    requiresAuth: true,
    order: 8,
  },
  children: [
    {
      path: 'order',
      name: 'ChargingOrder',
      component: () => import('@/views/charging/order/index.vue'),
      meta: {
        locale: '充电订单',
        requiresAuth: true,
      },
    },
    {
      path: 'refund',
      name: '退款列表',
      component: () => import('@/views/charging/refund/index.vue'),
      meta: {
        locale: '退款列表',
        requiresAuth: true,
      },
    },
    {
      path: 'self-order',
      name: 'SelfOrder',
      component: () => import('@/views/charging/self-order/index.vue'),
      meta: {
        locale: '自有平台充电订单',
        requiresAuth: true,
      },
    },
    // 可以添加更多充电管理相关的子路由...
  ],
};

export default CHARGING;
